<ui-panel name="Panel">
    Fill this up with yor custom html
</ui-panel>

<ui-panel name="Panel with Button" [buttonIcon]="'analytics'">
    Fill this up with yor custom html
</ui-panel>
